@if (isLoading) {
  <div class="spinner spinner_{{ color }}">
    <ion-spinner name="circles"></ion-spinner>
  </div>
}
